// styling constants for the JavaScript

// FIXME: This information is "duplicated" in the _base.scss file - that should be fixed some how. ¯\_(ツ)_/¯


const STYLE = Object.freeze({
  colors: {
    primary: '#002855',
    secondary: '#a7d500',
    neutral: '#ffffff'
  }
})

export default STYLE
